/* mask utility to mask and unmask numbers
 */

export const maskPhone = (phone_number: string): string => {
    return phone_number.replace(/^(\d{0,3})(\d{0,3})(\d*)/, '($1) $2-$3');
}

export const removeNonDigits = (masked_string: string): string => {
    return masked_string.replace(/\D/g, '')
}